document.querySelectorAll('.price__container[data-price="0"]').forEach(container => {
  const target = container.querySelector('.price__regular, .price__sale ins');
  if (target) {
    target.innerHTML = '<span>Free</span>';
  }
});

/**
 * price-show-max.js
 *
 * When a product has varying prices across variants, Shopify renders a range
 * like "20,90 € – 22,90 €". This script hides the lower bound so only the
 * higher (max) price is shown on product cards across the whole storefront.
 *
 * Handles all price patterns from snippets/price.liquid:
 *   - price__regular  (regular range)
 *   - price__sale > ins  (on-sale range, which may include a "From" text node)
 *
 * Also re-runs whenever new products are injected by dynamic-load-more.js
 * (infinite scroll / "Load more" button) via a MutationObserver.
 */
(function () {
  /**
   * Process a single dash separator element and hide the min-price siblings.
   * Skips elements that have already been processed.
   */
  function processDash(dash) {
    if (dash.dataset.priceMaxProcessed) return;
    if (dash.textContent.trim() !== '-') return;

    dash.dataset.priceMaxProcessed = '1';
    dash.style.display = 'none';

    // The two siblings before the dash:
    //   previousElementSibling        → min price value span
    //   .previousElementSibling again → visually-hidden "Minimum price" label
    const minValue = dash.previousElementSibling;
    if (minValue) minValue.style.display = 'none';

    const minLabel = minValue && minValue.previousElementSibling;
    if (minLabel) minLabel.style.display = 'none';

    // When inside an <ins> (sale range) there may be a leading "From" text node.
    // Wrap it in a hidden <span> so it can be toggled cleanly.
    const ins = dash.closest('ins');
    if (ins) {
      ins.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
          const wrapper = document.createElement('span');
          wrapper.style.display = 'none';
          wrapper.textContent = node.textContent;
          ins.replaceChild(wrapper, node);
        }
      });
    }
  }

  /** Run over all price containers inside a given root element (or the whole document). */
  function hideMinPriceIn(root) {
    root
      .querySelectorAll('.price__container span[aria-hidden="true"]')
      .forEach(processDash);
  }

  /** Watch a grid element and re-process prices whenever new nodes are appended. */
  function observeGrid(grid) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          // Process price ranges inside the newly added card(s)
          hideMinPriceIn(node);
          // Also handle the case where the node itself is a price container
          if (node.matches && node.matches('.price__container')) {
            node
              .querySelectorAll('span[aria-hidden="true"]')
              .forEach(processDash);
          }
        });
      });
    });

    observer.observe(grid, { childList: true, subtree: true });
  }

  function init() {
    // Initial pass over the whole page
    hideMinPriceIn(document);

    // Watch every product/collection grid that dynamic-load-more.js may append to
    const grids = document.querySelectorAll(
      '#product-grid, #collection-grid'
    );
    grids.forEach(observeGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


document.querySelectorAll('.section-carousel__block').forEach(block => {
  if (block.querySelector('a')) block.classList.add('has-link');
});


//Hide Laine Magazine Subscription product price
document.addEventListener('DOMContentLoaded', function () {
  const TARGET_TITLE = "Laine Magazine Subscription";

  function hidePriceIfMatch() {
    // Works on product pages
    const productTitle = document.querySelector('.product__title, h1.title, h1[itemprop="name"]');
    if (productTitle && productTitle.textContent.trim() === TARGET_TITLE) {
      const priceSelectors = [
        '.price',
        '.product__price',
        '.price-wrapper',
        '[data-product-price]',
        '.price__container',
        '.price-item',
      ];
      priceSelectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          el.style.display = 'none';
        });
      });
    }

    // Works on collection pages (product cards)
    document.querySelectorAll('.card__heading, .card-information__text h3, .product-card__title').forEach(titleEl => {
      if (titleEl.textContent.trim() === TARGET_TITLE) {
        const card = titleEl.closest('.card-wrapper, .product-card, .grid__item');
        if (card) {
          card.querySelectorAll('.price, .card-information__price, [data-product-price]').forEach(el => {
            el.style.display = 'none';
          });
        }
      }
    });
  }

  hidePriceIfMatch();
});

(function () {
  const PREORDER_BADGE_TEXT = ['preorder', 'ennakkotilaus'];
  const NEW_LABEL_TEXT = 'Preorder';

  function updateButton(card) {
    const button = card.querySelector('.product-card__add-to-cart--button');
    if (!button || button.classList.contains('product-card__add-to-cart--preorder')) return;

    // Remove the plus icon
    const icon = button.querySelector('svg');
    if (icon) icon.remove();

    // Reveal and update the label (was visually-hidden, e.g. "Choose options")
    const label = button.querySelector('span.visually-hidden');
    if (label) {
      label.classList.remove('visually-hidden');
      label.textContent = NEW_LABEL_TEXT;
    } else {
      const span = document.createElement('span');
      span.textContent = NEW_LABEL_TEXT;
      button.insertBefore(span, button.querySelector('.quick-cart-drawer__trigger--loading'));
    }

    // Swap icon-only styling for text-button styling
    button.classList.remove('button--icon', 'button--rounded-0');
    button.classList.add('button--uppercase', 'button--filled');

    button.classList.add('product-card__add-to-cart--preorder');
  }

  function hidePreorderBadge(badge) {
    badge.style.display = 'none';
  }

  function showActionsAlways(card) {
    const actions = card.querySelector('.product-card__actions');
    if (actions) actions.classList.add('product-card__actions--always-visible');
  }

  function scanCards() {
    document.querySelectorAll('product-card').forEach((card) => {
      const badges = card.querySelectorAll('.product-card__badge');
      const preorderBadge = Array.from(badges).find((badge) =>
        PREORDER_BADGE_TEXT.includes(badge.textContent.trim().toLowerCase())
      );
      if (preorderBadge) {
        updateButton(card);
        hidePreorderBadge(preorderBadge);
        showActionsAlways(card);
      }
    });
  }

  function init() {
    scanCards();

    const observer = new MutationObserver(() => {
      clearTimeout(window.__preorderBtnScanTimeout);
      window.__preorderBtnScanTimeout = setTimeout(scanCards, 300);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();